import { render } from "./FormCheckbox.vue?vue&type=template&id=8f69e0ac"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script